import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Step from '../views/Step.vue';
import Map from '../views/Map.vue';
import StepList from '../views/StepList.vue';
import Reset    from '../views/Reset.vue';

const routes = [
    { path: '/', component: Home },
    { path: '/step/:id', component: Step, props: true },
    { path: '/map', component: Map,props: { br: 4 } },
    { path: '/steps', component: StepList},
    { path: '/reset',  component: Reset },
    // catch-all pour SPA
    { path: '/:catchAll(.*)', redirect: '/' }
];

export default createRouter({
    history: createWebHistory(),
    routes,
});
